<template>
  <div class="scanner-button">
    <!-- 掃描器按鈕 -->
    <BaseElButton
      type="text"
      @click="dialogVisible = true"
    >
      <SVGIcon icon="common-scanner_gun" />
    </BaseElButton>

    <!-- 掃描彈窗 -->
    <ScannerDialog
      v-if="dialogVisible"
      @close="dialogVisible = false"
    />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import SVGIcon from '@/components/SVGIcon.vue'
import ScannerDialog from './ScannerDialog.vue'

export default defineComponent({
  name: 'ScannerButton',
  components: {
    SVGIcon,
    ScannerDialog,
  },
  setup () {
    const dialogVisible = ref(false)

    return {
      dialogVisible,
    }
  },
})
</script>
